import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Alert,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { EditLevel2 } from "../../redux/actions/EditLevel2Action";

const EditLevel2Modal = ({ open, onClose, level2Data }) => {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.editLevel2.status);
  const [form, setForm] = useState({
    idmenuLevel2: "",
    name: "",
    isActive: true,
    createdBy: "",
    createdDate: "",
    modifiedBy: "",
    modifiedDate: "",
    idCountry: "",
  });
  const [message, setMessage] = useState({ type: "", text: "" });
  const loading = status === "loading";

  useEffect(() => {
    if (level2Data && open) {
      setForm({
        idmenuLevel2: level2Data.idmenuLevel2 ?? "",
        name: level2Data.name || "",
        isActive: level2Data.isActive ?? true,
        createdBy: level2Data.createdBy || "",
        createdDate: level2Data.createdDate || "",
        modifiedBy: level2Data.modifiedBy || "",
        modifiedDate: level2Data.modifiedDate || "",
        idCountry: level2Data.idCountry || "",
      });
      setMessage({ type: "", text: "" });
    }
  }, [level2Data, open]);

  const isFormValid = () =>
    form.idmenuLevel2 !== "" && form.name.trim() !== "";

  const handleClose = () => {
    onClose();
  };

  const handleSave = async () => {
    setMessage({ type: "", text: "" });

    try {
      const result = await dispatch(EditLevel2(form));

      if (result.success) {
        setMessage({ type: "success", text: result.message });
        setTimeout(() => {
          handleClose();
        }, 1500);
      } else {
        setMessage({ type: "error", text: result.message });
      }
    } catch {
      setMessage({
        type: "error",
        text: "There was an error updating the category. Please try again.",
      });
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Category</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <TextField
            label="ID"
            value={form.idmenuLevel2}
            fullWidth
            disabled
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            fullWidth
            required
            disabled={loading}
          />
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={(e) =>
                  setForm({ ...form, isActive: e.target.checked })
                }
                disabled={loading}
              />
            }
            label="Active"
          />

          {message.text && (
            <Alert
              severity={message.type}
              onClose={() => setMessage({ type: "", text: "" })}
            >
              {message.text}
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!isFormValid() || loading}
          startIcon={
            loading ? <CircularProgress size={20} color="inherit" /> : null
          }
          sx={{
            backgroundColor: "#4b4bfa",
            "&:hover": { backgroundColor: "#3e3ed9" },
            color: "#fff",
          }}
        >
          {loading ? "Saving..." : "Save Changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditLevel2Modal;
